import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=d402ddec"
import script from "./Speciality.vue?vue&type=script&lang=js"
export * from "./Speciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports